import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Interviewee, ObjectUtils, StringUtils } from '@smooved/core';
import { Observable } from 'rxjs';
import { SURVEY_CONFIG } from '../constants/surveys.constants';
import * as uri from '../constants/uri.constants';
import { SurveyType } from '../enums';
import { InterviewInitiatedByType } from '../enums/interview-initiated-by-type.enum';
import { Interview } from '../interfaces/meta/interview';
import { SurveyConfig } from '../interfaces/survey-config.interface';
import { SurveyProvidersModule } from '../survey-providers.module';

@Injectable({
    providedIn: SurveyProvidersModule,
})
export class SurveyDataService {
    constructor(private httpClient: HttpClient, @Optional() @Inject(SURVEY_CONFIG) public readonly config: SurveyConfig) {}

    public getInterview(request: {
        interviewee: Interviewee;
        initiatedBy: InterviewInitiatedByType;
        surveyType: SurveyType;
    }): Observable<Interview> {
        const params = { initiatedBy: request.initiatedBy, type: request.surveyType };
        ObjectUtils.removeEmpty(params);
        return this.httpClient.get<Interview>(
            StringUtils.parseUri(uri.interviewUri, { baseUri: this.config.baseUrl, interviewee: request.interviewee }),
            {
                params,
            }
        );
    }
}
